/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
import React, { FC } from "react";
import { Box } from "../../../../../components/box";
import FontFa from "../../../../../components/fontFa/fontFa";
import { useEmployee } from "../../../../../hook";
import { useGetDetailRequests } from "../hooks";
import { requestStatus } from "../../../../../constants";
import { getDDMMYYYFormat } from "../../../../../helper/dateTimeHelper";
import { Skeleton } from "antd";
import { getHHmmFormat } from "../../../../../helper/dateTimeHelper";
import { DETAIL } from "../constant";
import { getEmployeeDetail } from "../utils/get-employee-detail";
import { useSelector } from "../../../../../store/store";

export const ExportProgress: FC = () => {
  const { data: employees, isLoading: isLoadingEmployees } = useEmployee();
  const softwares = useSelector((state: any) => state.systemMgmt.softwares);
  const { data: detail, isLoading: isLoadingDetailRequest }: any = useGetDetailRequests();

  if (isLoadingEmployees || isLoadingDetailRequest) return <Skeleton />;

  const getStatus = (status: string) => {
    if (status == requestStatus.approved) return requestStatus.approved;
    if (status == requestStatus.rejected) return requestStatus.rejected;
    return requestStatus.submitted;
  };

  const getTitle = (detail: any, eLocation: string) => {
    if (eLocation === "NBA") return detail.NBTitle;
    if (eLocation === "DAD") return detail.DNTitle;
    return detail.title;
  };

  return (
    <Box title="Quy trình duyệt">
      <div className="TimelineBox horizontal mdHorizontal mdSmall">
        <div className="item">
          <div className="step approved">
            <FontFa name="faCheck" />
          </div>
          <div className="content">
            <div className="rank">
              <h6>Khởi tạo</h6>
            </div>
            <div className="title">{detail?.createdBy?.user?.displayName}</div>
            <div className="title">{detail?.createdBy?.user?.email} </div>
            <div className="time">
              {`Ngày tạo: ${getDDMMYYYFormat(detail?.createdDateTime)} - ${getHHmmFormat(detail?.createdDateTime)}`}
            </div>
          </div>
        </div>

        {DETAIL.progress.map((value) => {
          if (value.step === 1) {
            return (
              <div className="item">
                {getStatus(detail?.fields?.eApprovedStatus) === requestStatus.approved && (
                  <div className={`step approved`}>
                    <FontFa name="faCheck" />
                  </div>
                )}

                {getStatus(detail?.fields?.eApprovedStatus) === requestStatus.rejected && (
                  <div className={`step rejected`}>
                    <FontFa name="faBan" />
                  </div>
                )}

                {getStatus(detail?.fields?.eApprovedStatus) === requestStatus.submitted && (
                  <div className={`step waiting`}>
                    <FontFa name="faCheck" />
                  </div>
                )}

                <div className="content">
                  <div className="rank">
                    <h6>{getTitle(value, detail.fields.eLocation)}</h6>
                  </div>
                  <div className="title">
                    {getEmployeeDetail(detail?.fields?.eApprovedBy, employees, softwares)?.[0]?.Title}
                  </div>
                  <div className="title">
                    {getEmployeeDetail(detail?.fields?.eApprovedBy, employees, softwares)?.[0]?.eMail}
                  </div>
                  {[requestStatus.approved, requestStatus.rejected].includes(detail?.fields?.eApprovedStatus) && (
                    <div className="time">{`Ngày duyệt: ${getDDMMYYYFormat(
                      detail?.fields?.eApprovedDate,
                    )} - ${getHHmmFormat(detail?.fields?.eApprovedDate)}`}</div>
                  )}
                </div>
              </div>
            );
          }
          if (value.step === 2) {
            return (
              <div className="item">
                {getStatus(detail?.fields?.eApprovedByITLeadStatus) === requestStatus.approved && (
                  <div className={`step approved`}>
                    <FontFa name="faCheck" />
                  </div>
                )}

                {getStatus(detail?.fields?.eApprovedByITLeadStatus) === requestStatus.rejected && (
                  <div className={`step rejected`}>
                    <FontFa name="faBan" />
                  </div>
                )}

                {getStatus(detail?.fields?.eApprovedByITLeadStatus) === requestStatus.submitted && (
                  <div className={`step waiting`}>
                    <FontFa name="faCheck" />
                  </div>
                )}

                <div className="content">
                  <div className="rank">
                    <h6>{getTitle(value, detail.fields.eLocation)}</h6>
                  </div>
                  <div className="title">
                    {getEmployeeDetail(detail?.fields?.eApprovedByITLead, employees, softwares)?.[0]?.Title}
                  </div>
                  <div className="title">
                    {getEmployeeDetail(detail?.fields?.eApprovedByITLead, employees, softwares)?.[0]?.eMail}
                  </div>
                  {[requestStatus.approved, requestStatus.rejected].includes(detail?.fields?.eApprovedByITLeadStatus) &&
                    detail?.fields?.eApprovedDate && (
                      <div className="time">{`Ngày duyệt: ${getDDMMYYYFormat(
                        detail?.fields?.eApprovedDate,
                      )} - ${getHHmmFormat(detail?.fields?.eApprovedDate)}`}</div>
                    )}
                </div>
              </div>
            );
          }
        })}
      </div>
    </Box>
  );
};
